import React from 'react'

import type { AllProductUpdatesQuery } from 'generated/resources/graphql'

type ProductUpdatesUpdate =
  AllProductUpdatesQuery['productUpdates']['updatesConnection']['edges'][number]['node']

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useGetProductUpdates } from 'modules/product_updates/hooks/useGetProductUpdates'

import { Config as ProductUpdatesConfig } from '../lib/types'
import { getProductUpdatesVisibility } from '../lib/visibility'

type WidgetConfig = Omit<ProductUpdatesConfig, 'routes'> & {
  productUpdates: ProductUpdatesUpdate[]
}

export const useProductUpdatesVisibility = (currentPath: string): WidgetConfig => {
  const { navigation } = useNavigation()
  const visibilityConfig = getProductUpdatesVisibility(navigation)

  const productConfig = React.useMemo(() => {
    const matchingEntry = Object.entries(visibilityConfig).find(([_, config]) =>
      config.routes.some((path) => currentPath.startsWith(path))
    )

    return matchingEntry ? matchingEntry[1] : undefined
  }, [currentPath, visibilityConfig])

  const { productUpdates } = useGetProductUpdates({
    releasedAfter: 10,
  })

  const filteredProductUpdates = React.useMemo(() => {
    if (!productConfig) {
      return []
    }
    return productUpdates.filter(
      (update) => update.productModule.urlIdentifier === productConfig.moduleName
    )
  }, [productUpdates, productConfig])

  return {
    productName: productConfig?.productName || '',
    moduleName: productConfig?.moduleName || '',
    productUpdates: filteredProductUpdates,
  }
}
